var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.html)?_c('div',{staticClass:"cms-partial"},[_c(_vm.htmlComponent,{tag:"component"}),(_vm.css)?_c("style",{tag:"component"},[_vm._v(_vm._s(_vm.css))]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }